var $ae0450e8bb2a56df$exports = {};
$ae0450e8bb2a56df$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


export {$ae0450e8bb2a56df$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
